import { IntegrationsPortErrors } from 'modules/Integrations/domain'
import type { NumeralIntegrationConfig } from './numeral.integration.config'

export const numeralConfigurationLoader = (): Promise<{
  data: NumeralIntegrationConfig | null
  error: IntegrationsPortErrors | null
}> => {
  return Promise.resolve({
    data: {
      obfuscatedApiKey: ''
    },
    error: null
  })
}
